// Telegram Mini App detection utility
export const isTelegramMiniApp = () => {
  // Strict check - must have Telegram WebApp object with valid data
  return !!(window.Telegram?.WebApp?.initData && window.Telegram?.WebApp?.version);
};

export const getTelegramWebApp = () => window.Telegram?.WebApp || null;

export const getTelegramInitData = () => {
  const initData = window.Telegram?.WebApp?.initData;
  return typeof initData === 'string' ? initData.trim() : '';
};

export const getTelegramMiniAppUser = () => {
  const user = window.Telegram?.WebApp?.initDataUnsafe?.user;
  return user && typeof user === 'object' ? user : null;
};

// Initialize Telegram WebApp if available
export const initTelegramWebApp = () => {
  if (window.Telegram?.WebApp) {
    const tg = window.Telegram.WebApp;
    tg.ready();
    tg.expand();
    return tg;
  }
  return null;
};

export const openTelegramLink = (url) => {
  const link = typeof url === 'string' ? url.trim() : '';
  if (!link) return false;

  const tg = window.Telegram?.WebApp;
  if (tg?.openTelegramLink) {
    try {
      tg.openTelegramLink(link);
      return true;
    } catch (error) {
      console.warn('Telegram WebApp openTelegramLink failed, falling back to browser navigation.', error);
    }
  }

  window.location.assign(link);
  return true;
};

export const openTelegramBotChat = (botUsername) => {
  const username = typeof botUsername === 'string' ? botUsername.trim().replace(/^@/, '') : '';
  if (!username) return false;
  return openTelegramLink(`https://t.me/${username}`);
};
